<template>
  <header ref="theHeader" class="the-header bg-transparent fixed w-full top-0 z-30 transition duration-300 ease-in-out">
    <div class="n-container h-full flex items-center justify-start space-x-3">
      <img :src="logo" class="h-8 w-[100px] md:w-fit" alt="" />
      <div class="flex-1"></div>
      <NChannelSwitch theme="white" />
      <NLanguageSwitcher class="text-white" />
      <NHelper :class="'!text-white'" />
      <NButton shape="circle" :type="logoutBtnType" @click="onLogout()"><i class="fas fa-sign-out-alt" /></NButton>
      <NButton shape="circle" :type="logoutBtnType" class="md:!hidden" @click="onToggle()">
        <template #icon><i class="fas fa-bars" /></template>
      </NButton>
      <div v-if="toggleValue" class="c-mobile-menus md:hidden absolute w-full top-20 left-0 !m-0">
        <div
          v-for="item in menus"
          :key="item.title"
          class="c-mobile-menu flex items-center px-5 py-3 bg-white last:border-b hover:bg-blue-50 cursor-pointer"
          @click="onClickMenuItem(item)"
        >
          <i class="mr-3 w-[23px]" :class="item.icon" />
          {{ $t(item.name) }}
        </div>
      </div>
    </div>
  </header>
  <div v-if="toggleValue" class="fixed inset-0 opacity-70 bg-white z-20 md:hidden" @mousedown="onToggle"></div>
</template>

<script setup>
import {computed, ref} from 'vue';
import {removeToken} from '@/services';
import {domainEvent, useDomResize, useRouter, useScroll, useToggle} from '@front/hooks';
import {logout} from '@front/api/utility';

const props = defineProps({
  menus: Array,
});

const { routerTo } = useRouter();

const { scrollTop } = useScroll(document.body);
const theHeader = ref();
const { rect } = useDomResize(theHeader);

const logo = computed(() => `/images/logo-dark.svg`);
const logoutBtnType = computed(() => 'default');
const { toggleValue, onToggle } = useToggle();

function onLogout() {
  logout().catch(() => {}); // ignore error
  removeToken();
  domainEvent.dispatch('LOGOUT');
  routerTo('/login');
}

function onClickMenuItem(item) {
  routerTo(item.path);
  toggleValue.value = false;
}
</script>

<style lang="less" scoped>
@import '/src/page-front/style/config';

.the-header {
  height: @head-height;

  .c-nav-sticky {
    background-color: white;
    box-shadow: 0 1px 0 #ddd;
    button {
      color: white;
    }
  }
}
</style>
